import home from './home.json';
import global from './global.json';


export default {
    home,
    global
}
